import { getHostname } from "@/scripts/getHostname";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useAppSelector } from "../../../../store/hooks";
import { fetchLesson } from "../api/fetchLesson";
import useCheckIsMobile from "../utils/useCheckIsMobile";

export enum LessonTabs {
  QUIZ = "quiz",
  VIDEO = "video",
  HOMEWORK = "hw",
}

const useGetLesson = () => {
  // const { lesson } = useParams();
  const params = useParams();
  const lesson = params["*"]?.split("/").pop();
  console.log('fdsgsfjk', params["*"]?.split("/").pop())
  const [currentContent, setCurrentContent] = useState<LessonTabs>(
    LessonTabs.QUIZ
  ); // 'quiz' || 'video' || 'hw'
  const { user, userProfileData } = useAppSelector((state) => state.store);
  const isAuthenticated = user;
  const authPending = !user;

  const {
    data: lessonData,
    isPending,
    error,
  } = useQuery({
    queryKey: ["lesson", lesson, userProfileData],
    queryFn: () => fetchLesson(lesson),
    staleTime: Infinity,
  });

  useEffect(() => {
    if (lessonData) {
      setCurrentContent(LessonTabs.QUIZ);
    }
  }, [lesson]);

  const currentTimestamp = Date.now();
  const expiryTimestamp = Date.parse(lessonData?.last_purchase_date ?? "");

  const pastLastPurchaseDate =
    lessonData?.last_purchase_date && currentTimestamp > expiryTimestamp;
  const notFinishedPrereq = !lessonData?.finished_prerequisites;

  const isStudentBlocked =
    userProfileData &&
    userProfileData.disabled_sites &&
    userProfileData.disabled_sites.filter(
      (site) => site.toString() === getHostname().toString()
    ).length > 0;

  const { isMobile } = useCheckIsMobile();

  return {
    lessonData,
    isPending,
    error,
    currentContent,
    setCurrentContent,
    isAuthenticated,
    authPending,
    user,
    userProfileData,
    pastLastPurchaseDate,
    notFinishedPrereq,
    prerequisiteType: lessonData?.prerequisite_type,
    isStudentBlocked,
    isMobile,
  };
};

export default useGetLesson;
